module.exports = __webpack_public_path__ + "img/st-georges.0941d3c6.png";